<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">

        <a-row :gutter="24">
          <a-card title="基础信息"> 
              <a-col :span="12">
                <a-form-model-item label="工号" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="employeeNo">
                    <a-input v-model="model.employeeNo" placeholder="请输入工号" disabled></a-input>
                </a-form-model-item>
              </a-col>

              <a-col :span="12">
                <a-form-model-item label="姓名" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="name">
                    <a-input v-model="model.name" placeholder="请输入姓名" disabled></a-input>
                </a-form-model-item>
              </a-col>

              <a-col :span="24">
                <a-form-model-item label="法人" :labelCol="labelCol2" :wrapperCol="wrapperCol2" prop="legalPerson">
                  <a-input v-model="model.legalPerson" placeholder="请输入法人" disabled></a-input>
                </a-form-model-item>
              </a-col>


              <a-col :span="12" >
                <a-form-model-item label="事业群" :labelCol="labelCol"  :wrapperCol="wrapperCol" prop="buName">
                  <a-input v-model="model.buName" disabled="disabled"  ></a-input>
                </a-form-model-item>
              </a-col>

              <a-col :span="12" >
                <a-form-model-item label="事业处" :labelCol="labelCol" :wrapperCol="wrapperCol"  prop="buName">
                  <a-input v-model="model.buName"  disabled="disabled"  ></a-input>
                </a-form-model-item>            
              </a-col>


              <a-col :span="12">
                <a-form-model-item label="手机" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="mobile">
                  <a-input v-model="model.mobile" placeholder="请输入手机" disabled></a-input>
                </a-form-model-item>
              </a-col>

              <a-col :span="12">
                <a-form-model-item label="是否在职" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="isWork">
                    <j-dict-select-tag
                    type="list"
                    v-model="model.isWork"
                    dictCode="pre_job_status"
                    placeholder="请选择是否在职"
                    />
                </a-form-model-item>
            </a-col>

            <a-col :span="12">
                <a-form-model-item label="邮箱" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="email">
                  <a-input v-model="model.email" placeholder="请输入邮箱" disabled></a-input>
                </a-form-model-item>
            </a-col>
            </a-card>
        </a-row>
        
<!-- 厂区楼栋 -->
        <!-- <a-row :gutter="24">
          <a-card title="所属楼栋"> 
            
            <a-col :span="12">
                <a-form-model-item label="厂区" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="factoryId">
                  <a-select 
                    allowClear
                    placeholder="请选择厂区"
                    v-model="model.factoryId"
                    :options="factoryOptions"
                    @change="factoryChange"
                    disabled
                    />
                </a-form-model-item>
            </a-col>

            <a-col :span="12">
                <a-form-model-item label="区域" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="areaId">
                  <a-select 
                    allowClear
                    placeholder="请选择区域"
                    v-model="model.areaId"
                    :options="areaOptions"
                    @change="areaChange"
                    disabled
                    />
                </a-form-model-item>
            </a-col>

            <a-col :span="12">
                <a-form-model-item label="楼栋" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="buildingId">
                  <a-select 
                    allowClear
                    placeholder="请选择楼栋"
                    v-model="model.buildingId"
                    :options="buildingOptions"
                    @change="buildingChange"
                    disabled
                    />
                </a-form-model-item>
            </a-col>
          </a-card>
        </a-row>   -->

        <!-- <a-row :gutter="24">
          <a-card title="核酸情况"> 
            
            <a-col :span="12">
              <a-form-model-item label="健康码状态" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="healthCode">
                  <j-dict-select-tag
                  type="list"
                  v-model="model.healthCode"
                  dictCode="pre_health_status"
                  placeholder="请选择健康码状态"
                  />
              </a-form-model-item>
            </a-col>

            <a-col :span="12">
              <a-form-model-item label="核酸检测时间" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="detectionTime">
                <j-date placeholder="请选择核酸检测时间"  v-model="model.detectionTime" :show-time="true" date-format="YYYY-MM-DD HH:mm:ss" style="width: 100%" />
              </a-form-model-item>
            </a-col>

            <a-col :span="12">
              <a-form-model-item label="核酸结果" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="result">
                  <j-dict-select-tag
                  type="list"
                  v-model="model.result"
                  dictCode="pre_inspect_result"
                  placeholder="请选择核酸结果"
                  />
              </a-form-model-item>
            </a-col>

          </a-card>
        </a-row>   --> 

      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction,postAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'EmployeeForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
         },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 4 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        confirmLoading: false,
        url: {
          
          edit: "/prevent/epm/edit",
          queryById: "/prevent/epm/queryById",
        },
        factoryOptions:[],
        areaOptions:[],
        buildingOptions:[],
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
      language() {
        return this.$store.getters.language
      },
      validatorRules(){
          if(this.language){
            return {
              mobile: [
                  { required: true, message: '请输入手机'},
                  { pattern: /^1[3456789]\d{9}$/, message: '请输入正确格式的手机'},
              ],
              work: [
                  { required: true, message: '请选择是否在职'},
              ],
              email: [
                  { pattern: /^([a-zA-Z0-9]+[-_\.]?)+@([a-zA-Z0-9]+[-_\.]?)+$/, message: '请输入正确格式的邮箱'},
              ],

              factoryId: [
                  { required: true, message: '请选择厂区'},
              ],
              areaId: [
                  { required: true, message: '请选择区域'},
              ],
              buildingId: [
                  { required: true, message: '请选择楼栋'},
              ],

              healthCode: [
                  { required: true, message: '请选择健康码状态'},
              ],
              detectionTime: [
                  { required: true, message: '请输入核酸检测时间'},
              ],

              result: [
                  { required: true, message: '请输入核酸结果'},
              ],
            }
          }
      },
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));

      this.initFactoryOptions();
    },
    methods: {
      initFactoryOptions(){
        getAction('/prevent/factory/prefactorys',{pageNo:1,pageSize:100000}).then(res=>{
          if(res.success){
            this.factoryOptions = res.result.records.map((item,index,arr)=>{
              let c = {label:item.name, value: item.id}
              return c;
            })
			    }
        })

      },

      factoryChange(val){
        if(typeof val=='undefined'){
          this.areaOptions=[];
          return;
			   }
         let factoryIds =[]
         factoryIds.push(val)
         postAction('/prevent/area/getAreaByFactoryId',factoryIds).then(res=>{
           if(res.success){
              this.areaOptions = res.result.map((item,index,arr)=>{
                let c = {label:item.name, value: item.id}
                return c;
              })
			      }
         })

      },

      areaChange(val){
        if(typeof val=='undefined'){
          this.buildingOptions=[];
          return;
			   }
         let areaIds =[]
         areaIds.push(val)
         postAction('/prevent/building/getBuildingByAreaId',areaIds).then(res=>{
           if(res.success){
              this.buildingOptions = res.result.map((item,index,arr)=>{
                let c = {label:item.name, value: item.id}
                return c;
              })
			      }
         })

      },

      buildingChange(val){
        if(typeof val=='undefined'){
			     return;
			  }
			  this.model.buildingId=val;
      },


      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        //回显 厂区 区域 楼栋
        this.factoryChange(this.model.factoryId);
        this.areaChange(this.model.areaId)

        console.log('1:',this.model.detectionTime);
        if(this.model.detectionTime == '无记录'){
           this.$set(this.model,'detectionTime',null)
        }

        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
    }
  }
</script>